export default "__VITE_ASSET__ab343cc0__"